import { config } from './../../../../../config';
import { MatTableDataSource } from '@angular/material/table';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService, AlertService, PermissionService, CommunicationService } from 'src/app/services';
import { GlobalListComponent } from 'src/app/shared/global-list';
import * as moment from 'moment-timezone';
import * as momentTz from 'moment';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';

import { IntegrationsService } from '../../../../services/integrations.service';
import { InvoicesService } from '../../../../services/invoices.service';
import { Subscription } from 'rxjs';

import { IntegrationEnums } from '../../../../enums/integrations.enum';
import { Integration } from '../../../../models/models';
import { FinanceService } from '../../../../services/finance.service';
import { filter, take } from 'rxjs/operators';


@Component({
  selector: 'app-all-invoice-listing',
  templateUrl: './all-invoice-listing.component.html',
  styleUrls: ['/src/app/views/shared-style.scss', './all-invoice-listing.component.scss']
})
export class AllInvoiceListingComponent extends GlobalListComponent implements OnInit, OnDestroy {

  /* ------- Table Component Variables -----------*/

  buttonHeaderProps: any;
  tableConfigAndProps = {};
  footerProps: any;
  dataSource = new MatTableDataSource([]);
  tabIndex = 0;
  selectedInvoices: any[] = [];
  timeZone = momentTz().tz(moment.tz.guess()).format('Z');
  isRunningBatchJob : boolean = false;

  inputData = {
    'actionColumn': 'Actions',
    'buttonEvent': "output",
    'hasCheckBox': false,

  }
  Actionbuttons = [
    { buttonLabel: "Delete", type: 'delete', buttonRoute: "" },
  ]

  columnHeader = {
    'days': 'Days', 'sessionName': 'Session Name', 'attendedHrs': 'Attended Hrs', 'fundedHrs': 'Funded Hrs', 'qty': 'Qty', 'rate': 'Rate', 'amount': 'Amount', 'Actions': 'Actions'
  };

  headerButtons = [
    { buttonLabel: "Generate Invoice", color: "#E2AF2A", buttonRoute: "finance/generate-invoice/add", isMultiple: false, firstFormName: 'select-child', visibility: this.permissionsService.getPermissionsBySubModuleName('Finance Management', 'Invoice').create },
    { buttonLabel: "Adhoc Invoice", color: "#00AFBB", buttonRoute: "finance/adHocInvoice/add", isMultiple: false, firstFormName: 'select-child', visibility: this.permissionsService.getPermissionsBySubModuleName('Finance Management', 'Invoice').create },

    // { buttonLabel: "Marked as Approved", color: "#E2AF2A", buttonRoute: "child-Invoice/add", isMultiple: false, firstFormName: 'select-child', visibility: this.permissionsService.getPermissionsBySubModuleName('Finance Management', 'Invoice').create },

    // { buttonLabel: "Ad Hoc Invoice", color: "#00AFBB", buttonRoute: "child-Invoice/add", isMultiple: false, firstFormName: 'select-child', visibility: this.permissionsService.getPermissionsBySubModuleName('Finance Management', 'Invoice').create },

  ];

  /* ------- End -----------*/

  // ----- Variables for recurrsion ----//
    currentIndex = 0;
    splittedInvoicesArr: any[] = [];
    chunkSize = 20;
    numberOfChunks = 0;

  constructor(public _financeService: FinanceService, private dialog: MatDialog,protected _invoiceService: InvoicesService, protected router: Router, protected apiService: ApiService, protected _route: ActivatedRoute, protected alertService: AlertService, protected permissionService: PermissionService, protected communicationService: CommunicationService,private integrationService: IntegrationsService, private cdr: ChangeDetectorRef
  ) {
    super(router, apiService, alertService, permissionService);

    // console.log((this.integrationService.isXeroEnabled$ | async))

    this.buttonHeaderProps = {
      headingLabel: "All Invoices",
      ActionButtons: this.headerButtons,
      hasButton: true,
      hasHeading: true,
      labelMargin: '0px',
      float: 'right',
      textclass: 'text-bolder text-color',
      buttonsMargin: '0px 10px 0px',
      margin: '10px'
    };

    this.tableConfigAndProps = {
      ActionButtons: this.Actionbuttons,
      inputData: this.inputData, columnHeader: this.columnHeader, dataSource: this.dataSource,
    };
  }

  ngOnInit(): void {
    this.getXeroState();
    if (localStorage.getItem('invoiceTab')) {
      this.tabIndex = Number(localStorage.getItem('invoiceTab'));
      this.setTabIndex(this.tabIndex, false);
    }
    // Subscribe to the service state to get the current value    
  }

  getXeroState(){
    this.integrationService.integrations$.subscribe(
      (integrations: Integration []) => {
        console.log(integrations, '<===== INVOICES');
        const xero: Integration | undefined = integrations.find((ixn: Integration )=>{
          return ixn.platform === IntegrationEnums.XERO;
        }) 
      }
    );
  }

  setTabIndex(index, setTab) {
    this.tabIndex = index;
    if (setTab) {
      localStorage.setItem('invoiceTab', JSON.stringify(this.tabIndex));
    }

    // Refreshing Listing of selected Tab

    let tabName = this.tabIndex == 0 ? 'all' : this.tabIndex == 1 ? 'drafts' : this.tabIndex == 2 ? 'approved' : 'published';
    this.communicationService.updateInvoiceListing.next(tabName);

    // Setting listing of selected Tab
    switch (this.tabIndex) {
      case 0:
        this.buttonHeaderProps['ActionButtons'] = [
          { buttonLabel: "Generate Invoice", color: "#E2AF2A", buttonRoute: "finance/generate-invoice/add", isMultiple: false, firstFormName: 'select-child', visibility: this.permissionsService.getPermissionsBySubModuleName('Finance Management', 'Invoice').create },
          { buttonLabel: "Adhoc Invoice", color: "#00AFBB", buttonRoute: "finance/adHocInvoice/add", isMultiple: false, firstFormName: 'select-child', visibility: this.permissionsService.getPermissionsBySubModuleName('Finance Management', 'Invoice').create },
        ]
        break;

      case 1:
        this.checkBatchJob()
        this.buttonHeaderProps['ActionButtons'] = [
          { buttonLabel: "Download PDF", color: "#E2AF2A", buttonRoute: "", type: "output", visibility: false },
          { buttonLabel: "Marked as Approved", color: "#00AFBB", type: 'output', isMultiple: false, firstFormName: 'select-child', visibility: this.permissionsService.getPermissionsBySubModuleName('Finance Management', 'Invoice').update, disabled: true },
          { buttonLabel: "Delete", color: "#EB3026", type: 'output', isMultiple: false, firstFormName: 'select-child', visibility: this.permissionsService.getPermissionsBySubModuleName('Finance Management', 'Invoice').delete, disabled: true },
        ]        
        break;

      case 2:
        this.buttonHeaderProps['ActionButtons'] = [
          { buttonLabel: "Download PDF", color: "#E2AF2A", buttonRoute: "", type: "output", visibility: false },
          { buttonLabel: "Export as CSV", color: "#E2AF2A", type: 'output', isMultiple: false, firstFormName: 'select-child', visibility: this.permissionsService.getPermissionsBySubModuleName('Finance Management', 'Invoice').read, disabled: true },
        ]
        break;

      case 3:
        this.buttonHeaderProps['ActionButtons'] = [
          { buttonLabel: "Download PDF", color: "#E2AF2A", buttonRoute: "", type: "output", visibility: false },
          // { buttonLabel: "Export as CSV", color: "#E2AF2A", buttonRoute: "child-Invoice/add", isMultiple: false, firstFormName: 'select-child', visibility: this.permissionsService.getPermissionsBySubModuleName('Finance Management', 'Invoice').create },
        ]
        break;

      default:
        break;
    }

  }

  async checkBatchJob(){
    const invoiceIds: string | null = localStorage.getItem('invoiceIds');
    if(!invoiceIds){
      this.isRunningBatchJob = false;
      return;
    }
    let payload = {
      invoiceIds:JSON.parse(invoiceIds).exist
    };
    try {
      const res = await this._invoiceService.checkBatchJob(payload);      
      if (res.code == 200 || res.code == 201) {
        this.isRunningBatchJob = !res?.data?.result;        
        if(res.data.result == true){
          localStorage.removeItem('invoiceIds');
        } 
      }
            
    } catch (err) {
      this.alertService.alertError(err.error.status, err.error.message).then(result => {
        this.communicationService.updateInvoiceListing.next();
      })
    }
  
  }

  getSelectedInvoices(invoices) {
    this.selectedInvoices = invoices;
    if (this.tabIndex == 1 || this.tabIndex == 2) {
      if (this.selectedInvoices.length == 0 || this.isRunningBatchJob) {
        this.buttonHeaderProps.ActionButtons[1].disabled = true;
        this.buttonHeaderProps.ActionButtons[2].disabled = true;
      } else {
        delete this.buttonHeaderProps.ActionButtons[1]['disabled'];
        delete this.buttonHeaderProps.ActionButtons[2]['disabled'];
      }
    }
    this.setVisibilityPdf();
  }

  headerOutputAction(event) {
    console.log(event);
    let currentScreen = this.tabIndex == 1 ? 'drafts' : this.tabIndex == 2 ? 'approved' : 'published';

    if (this.selectedInvoices.length == 0) {
      return;
    }

    if (event.buttonLabel == 'Download PDF') {
      this.downloadSelectedPdf(currentScreen);
    }

    if (event.buttonLabel == 'Export as CSV') {
      this.initiateCSVExport();
    }

    if (event.buttonLabel == 'Marked as Approved') {
      this.confirmInvoiceApprove();
    }

    if (event.buttonLabel == 'Delete') {
      this.askDelete();
    }
  }

  async approveInvoices() {
    const isXeroEnabled = await this._financeService.isXeroEnabled$
      .pipe(
        filter((value) => value !== null),
        take(1))
      .toPromise();
    let endpoint: any = null;
    
    if(!isXeroEnabled){
      endpoint =config.base_url_slug + `approve/invoice?xeroEnabled=false`
    }else{
      endpoint =config.base_url_slug + `approve/invoice?xeroEnabled=true`
    } 
    if(!endpoint){
      return;
    }
    let invoices = this.selectedInvoices.map(invoice => invoice.id);
    let data = { invoiceIds: invoices };
    this.apiService.post(endpoint, data, false).then((res) => {      
      this.buttonHeaderProps.ActionButtons[0].visibility = false;
      this.buttonHeaderProps.ActionButtons[1].disabled = true;
      this.buttonHeaderProps.ActionButtons[0].disabled = true;
      this.selectedInvoices = [];

      localStorage.setItem('invoiceIds', JSON.stringify(res?.data));


      let message = res.code == 200 ? 'Invoice(s) Approved' : res.message;
      console.log(res, "APPROVE INVOICE RESPONSE");
      if(isXeroEnabled){
        // stringify all invoice ids in notExist array of response to concat along with success message
        if(res?.data?.notExist?.length && res?.data?.exist?.length){
          let unapprovedInvoiceIds  = res.data.notExist.map((invoiceId: number) => invoiceId.toString()).join(', ');
          console.log(unapprovedInvoiceIds);
          this.alertService.alertInfo(res.status, message + `<br/> Invoice(s) with ID(s) ${unapprovedInvoiceIds} not sent to Xero due to missing Xero contact.`);
        }
        else if(res?.data?.notExist?.length && !res?.data?.exist?.length){
          let unapprovedInvoiceIds  = res.data.notExist.map((invoiceId: number) => invoiceId.toString()).join(', ');
          console.log(unapprovedInvoiceIds);
          this.alertService.alertInfo("WARNING", `Invoice(s) with ID(s) ${unapprovedInvoiceIds} not sent to Xero due to missing Xero contact.`);
        }else {
          this.alertService.alertSuccess(res.status, message).then(result => {
            this.communicationService.updateInvoiceListing.next();
            if(invoices.length > 1){
              this.tabIndex = 2;
              this.setTabIndex(this.tabIndex, true)
            }
          })
        }
      }else{
        this.alertService.alertSuccess(res.status, message).then(result => {
          this.communicationService.updateInvoiceListing.next();
          if(invoices.length > 1){
            this.tabIndex = 2;
            this.setTabIndex(this.tabIndex, true)
          }
        })
      }
    

     
    })
      .catch(err => {
        this.alertService.alertError(err.error.status, err.error.message).then(result => {
          this.communicationService.updateInvoiceListing.next();
        })
      })
  }

  confirmInvoiceApprove() {
    let heading = 'Confirmation';
    let message = 'Are you sure you want to approve the invoice(s) ?';
    let rightButton = 'Approve';
    let leftButton = 'Cancel';

    this.alertService.alertAsk(heading, message, rightButton, leftButton, false).then((result) => {
      if (result) {
        this.approveInvoices();
      }
    });
  }

  deleteInvoices() {
    let url = config.base_url_slug + 'v2/remove/invoice';
    let invoices = this.selectedInvoices.map(invoice => invoice.id);
    let data = { invoiceIds: invoices };
    this.apiService.post(url, data).then((res) => {
      console.log(res);
      if (res.code == 200 || res.code == 201) {

        // setTimeout(() => {
        this.communicationService.updateInvoiceListing.next('drafts');
        // }, 2500);

        // this.router.navigate(['main/finance/allInvoice']);
        // this.buttonHeaderProps.ActionButtons[0].visibility = false;
        this.buttonHeaderProps.ActionButtons[0].visibility = false;
        this.buttonHeaderProps.ActionButtons[1].disabled = true;
        this.buttonHeaderProps.ActionButtons[2].disabled = true;
        // this.selectedInvoices = [];
        // this.downloadPdf(res.data);
        // this.communicationService.updateInvoiceListing.next('approved');
        // this.alertService.alertSuccess('SUCCESS', 'Invoice Generated Successfully');
      } else {
        this.alertService.alertInfo('Message', 'Data not available');
      }
    })
      .catch(err => console.log(err));
  }

  initiateCSVExport() {

      // Logic for dividing 20 selected guardians into parts with seperate api calls

      const length = this.selectedInvoices.length;
      this.numberOfChunks = Math.ceil(length / this.chunkSize);
      console.log('Number of chunks:', this.numberOfChunks);
      const originalArray = this.selectedInvoices;
      const resultArray = [];
      for (let i = 0; i < originalArray.length; i += this.chunkSize) {
        const chunk = originalArray.slice(i, i + this.chunkSize);
        resultArray.push(chunk);
      }
  
      // this.splittedInvoicesArr = resultArray;
      this.splittedInvoicesArr = this.selectedInvoices;
  
      // End

      this.exportCsv();
  }

  async exportCsv() {
    const csvUrls = [];    
    let url = config.base_url_slug + 'generate/invoice-csv';
    let tempInvoices = this.splittedInvoicesArr;
    let invoices = tempInvoices.map(invoice => invoice.id);
    let data = { invoiceIds: invoices, timeZone: this.timeZone };
    this.apiService.post(url, data).then((res) => {
      if (res.code == 200 || res.code == 201 || res.code == 202) {
        console.log('exportCsv', res);
        if(res.data?.result === 'PREPARE'){
          this.alertService.alertInfo(res.status, res.message).then(result => {
            this.communicationService.updateInvoiceListing.next();
          })
          return ;
        }
        
        csvUrls.push(res.data);
        // if ((this.currentIndex + 1) == this.numberOfChunks) 
        // {
          // this.router.navigate(['main/finance/allInvoice']);
          console.log('csv urls', csvUrls);
          this.buttonHeaderProps.ActionButtons[0].visibility = false;
          this.buttonHeaderProps.ActionButtons[1].disabled = true;
          this.selectedInvoices = [];
          this.fetchCSV(csvUrls);
          // setTimeout(()=> {
          //   this.downloadPdf(res.data);
          // }, 1000);
          this.communicationService.updateInvoiceListing.next('approved');
          setTimeout(() => {
            if(invoices.length > 1){
              this.tabIndex = 3;
              this.setTabIndex(this.tabIndex, true)
            }
          }, 300);
          // this.alertService.alertSuccess('SUCCESS', 'Invoice Generated Successfully');
        // } 
        // else 
        // {
        //   // Recurrsion for another api call
        //   this.currentIndex += 1;
        //   // this.fetchCSV(res.data, this.currentIndex)
        //   setTimeout(()=> {
        //     // this.downloadPdf(res.data);
        //     this.exportCsv();
        //   }, 1000);
        //   // this.exportCsv();
        // }

      }
    })
      .catch(err => {
          this.alertService.alertError(err.error.status, err.error.message).then(result => {
            this.communicationService.updateInvoiceListing.next();
          })
      });
  }

  async fetchCSV(csvUrls: any) {
    const zip = new JSZip();
    let count = 0;
    const retries = 5; // Number of retries for each URL
 
    // Helper function to fetch the file with retry logic
    async function fetchWithRetry(url: any, retriesLeft = retries) {
      let attempt = 0;
      let response;
 
      while (attempt < retriesLeft) {
        try {
          response = await fetch(url, { cache: 'no-store' });
 
          if (response.ok) {
            return response; // Return the response if it's successful
          }
 
          // Log the failed attempt if the response is not OK
          const responseBody = await response.text();
          console.error(
            `Attempt ${attempt + 1}: Failed to fetch: ${url} - Status: ${
              response.status
            } - Status Text: ${response.statusText}`
          );
        } catch (err) {
          console.error(
            `Attempt ${attempt + 1}: Error fetching the file from URL: ${url}`,
            err
          );
        }
 
        // Increment the attempt count and retry immediately
        attempt++;
        if (attempt < retriesLeft) {
          console.log(`Retrying... Attempt ${attempt + 1} for URL: ${url}`);
        }
      }
 
      // If all retries fail, throw an error
      throw new Error(`Failed to fetch after ${retriesLeft} attempts: ${url}`);
    }
 
    // Loop through all CSV URLs
    for (let url of csvUrls) {
      try {
        // Use the helper function to fetch with retry logic
        const response = await fetchWithRetry(url);
 
        // Convert the response to a Blob if the fetch is successful
        const data = await response.blob();
 
        count++;
        let fileName = url.split('/').pop(); // Extract the file name from the URL
        zip.file(fileName, data);
 
        // If all files are processed, create the zip and download it
        if (count === csvUrls.length) {
          const content = await zip.generateAsync({ type: 'blob' });
          saveAs(content, 'Invoices.zip');
          zip.files = {}; // Clear files after zipping
        }
 
        // If file is fetched and added to zip, no further retries will be made for this file
        break; // Exit the loop for this file after success
      } catch (err) {
        // Log the error if any occurs after maximum retries
        console.error(
          `Error fetching or processing the file from URL: ${url}`,
          err
        );
        // You can decide if you want to continue processing other files even if one fails
        // In this case, it will just skip the current file and move on to the next
      }
    }
  }

  // async fetchCSV(csvUrls: any) {
  //   // debugger;
  //   const zip = new JSZip();
  //   let count = 0;
  //   for (let url of csvUrls) {
  //     await fetch(url, { cache: 'no-store' })
  //       .then((response) => response.blob())
  //       .then((data) => {
  //         count++;
  //         let fileName = url.split('/').pop();
  //         zip.file(fileName, data);
  //         if (count == csvUrls.length) {
  //           zip.generateAsync({ type: 'blob' }).then(function (content) {
  //             saveAs(content, 'Invoices.zip');
  //           });
  //           zip.files = {};
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err, 'ERROOOOOOORRRRR');
  //       });
  //   }
  // }

  downloadPdf(url) {
    let link = document.createElement('a');
    link.href = url;
    link.download = url.substr(url.lastIndexOf('/') + 1);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadSelectedPdf(currentScreen) {
    let invoiceIds = this.selectedInvoices.map(x => x.id);
    let url = 'staff/download/invoice/pdf';
    this.apiService.post(url, { invoiceIds }).then((res) => {
      console.log(res);
      if (res.code == 200 || res.code == 201) {
        this.downloadPdf(res.data);
        // this.alertService.alertSuccess('SUCCESS', 'Invoice Deleted Successfully');
        this.communicationService.updateInvoiceListing.next(currentScreen);
        this.selectedInvoices = [];
        this.setVisibilityPdf();
      } else {
        this.alertService.alertError('ERROR', 'Data Not available');
      }
    })
      .catch(err => console.log(err));
  }

  setVisibilityPdf() {
    if (this.selectedInvoices.length > 0 && this.tabIndex != 0) {
      this.buttonHeaderProps['ActionButtons'][0].visibility = true;
    }
    else {
      this.buttonHeaderProps['ActionButtons'][0].visibility = false;
    }
  }

  askDelete() {
    let heading = 'Delete Item?';
    let message = 'Are you sure you want to delete ?';
    let rightButton = 'Delete';
    let leftButton = 'Cancel';
    this.alertService.alertAsk(heading, message, rightButton, leftButton, false).then(result => {
      if (result) {
        this.deleteInvoices();
      }
    })

  }

  getUpdatedTab(indexTab) {
    this.setTabIndex(indexTab, true);
  }

  ngOnDestroy(): void {
    console.log('destroyy');
    // localStorage.removeItem('invoiceTab');
  }

}
